import { ColumnDef } from "@tanstack/react-table";
import { DivergenceReport } from "./divergences-table";

const COLUMN_WIDTHS = {
  username: "180px",
  callId: "180px",
  caller: "180px",
  userAgent: "180px",
  service: "180px",
  reason: "180px",
  truncatedMessage: "180px",
  created: "180px",
};

export const columns: ColumnDef<DivergenceReport>[] = [
  {
    accessorKey: "username",
    header: "Username",
    cell: (info) => info.getValue(),
    enableSorting: true,
    meta: {
      width: COLUMN_WIDTHS.username,
    },
  },
  {
    accessorKey: "callId",
    header: "Call ID",
    cell: (info) => info.getValue(),
    enableSorting: true,
    meta: {
      width: COLUMN_WIDTHS.callId,
    },
  },
  {
    accessorKey: "caller",
    header: "Caller",
    cell: (info) => info.getValue(),
    enableSorting: true,
    meta: {
      width: COLUMN_WIDTHS.caller,
    },
  },
  {
    accessorKey: "userAgent",
    header: "User Agent",
    cell: (info) => info.getValue(),
    enableSorting: true,
    meta: {
      width: COLUMN_WIDTHS.userAgent,
    },
  },
  {
    accessorKey: "service",
    header: "Service",
    cell: (info) => info.getValue(),
    enableSorting: true,
    meta: {
      width: COLUMN_WIDTHS.service,
    },
  },
  {
    accessorKey: "reason",
    header: "Reason",
    cell: (info) => info.getValue(),
    enableSorting: true,
    meta: {
      width: COLUMN_WIDTHS.reason,
    },
  },
  {
    accessorKey: "message",
    header: "Message",
    cell: (info) => info.getValue(),
    enableSorting: true,
    meta: {
      width: COLUMN_WIDTHS.truncatedMessage,
    },
  },
  {
    accessorKey: "created",
    header: "Created",
    cell: (info) => new Date(info.getValue() as string).toLocaleString(),
    enableSorting: true,
    meta: {
      width: COLUMN_WIDTHS.created,
    },
  },
];
